export const GET_TEMPWAYTAGMODAL_DATA = "GET_TEMPWAYTAGMODAL_DATA"
export const UPDATE_TEMPWAYTAGMODAL_DATA = "GET_TEMPWAYTAGMODAL_DATA"
export const RESET_TEMPWAYTAGMODAL_DATA = "GET_TEMPWAYTAGMODAL_DATA"
export const WAYPOINTS_ORDERING_MODAL = "WAYPOINTS_ORDERING_MODAL"
